document.addEventListener('DOMContentLoaded', function(){

  // Countdown timer(s)
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var total = 4*3600 + 23*60 + 11;
    setInterval(function(){
      total = total > 0 ? total - 1 : 0;
      var h = String(Math.floor(total/3600)).padStart(2,'0');
      var m = String(Math.floor((total%3600)/60)).padStart(2,'0');
      var s = String(total%60).padStart(2,'0');
      el.textContent = h + ':' + m + ':' + s;
    }, 1000);
  });

  // Mobile drawer
  var drawer = document.getElementById('drawer');
  var drawerOverlay = document.getElementById('drawerOverlay');
  var hamburgerBtn = document.getElementById('hamburgerBtn');
  var drawerClose = document.getElementById('drawerClose');
  function closeDrawer(){ if(drawer) drawer.classList.remove('open'); if(drawerOverlay) drawerOverlay.classList.remove('open'); }
  if(hamburgerBtn) hamburgerBtn.addEventListener('click', function(){ drawer.classList.add('open'); drawerOverlay.classList.add('open'); });
  if(drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if(drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  // Product page: thumbnail gallery swap
  document.querySelectorAll('.pd-thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      document.querySelectorAll('.pd-thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = document.getElementById('pdMainImage');
      if(mainImg && thumb.dataset.fullsrc) mainImg.src = thumb.dataset.fullsrc;
    });
  });

  // Product page: sync option selects -> hidden variant id, image, price, availability
  var pdVariantDataEl = document.getElementById('pdVariantData');
  if(pdVariantDataEl){
    var pdVariants = JSON.parse(pdVariantDataEl.textContent);
    var pdOptionSelects = document.querySelectorAll('.pd-select');
    var pdHiddenId = document.querySelector('#pdProductForm select[name="id"]');
    var pdMainImg = document.getElementById('pdMainImage');
    var pdPriceNow = document.getElementById('pdPrice');
    var pdPriceOld = document.getElementById('pdComparePrice');
    var pdSubmitBtn = document.querySelector('.pd-add-cart-btn');

    function pdFormatMoney(cents){ return '$' + (cents / 100).toFixed(2); }

    function pdUpdateVariant(){
      var selected = Array.prototype.map.call(pdOptionSelects, function(s){ return s.value; });
      var match = pdVariants.filter(function(v){
        return v.options.length === selected.length && v.options.every(function(val, i){ return val === selected[i]; });
      })[0];
      if(!match) return;
      if(pdHiddenId) pdHiddenId.value = match.id;
      if(match.image && pdMainImg) pdMainImg.src = match.image;
      if(pdPriceNow) pdPriceNow.textContent = pdFormatMoney(match.price);
      if(pdPriceOld){
        if(match.compareAtPrice > match.price){
          pdPriceOld.textContent = pdFormatMoney(match.compareAtPrice);
          pdPriceOld.style.display = '';
        } else {
          pdPriceOld.style.display = 'none';
        }
      }
      if(pdSubmitBtn){
        pdSubmitBtn.disabled = !match.available;
        pdSubmitBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    pdOptionSelects.forEach(function(s){ s.addEventListener('change', pdUpdateVariant); });
  }

  // Product page: accordion
  document.querySelectorAll('.pd-acc-head').forEach(function(head){
    head.addEventListener('click', function(){
      var item = head.parentElement;
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.pd-acc-item').forEach(function(i){ i.classList.remove('open'); });
      if(!wasOpen) item.classList.add('open');
    });
  });

  // Scroll reveal animation
  var revealEls = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e, i){
        if(e.isIntersecting){
          setTimeout(function(){ e.target.classList.add('in'); }, i * 70);
          io.unobserve(e.target);
        }
      });
    }, {threshold:0.1});
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('in'); });
  }

  // AJAX Add to Cart (product form + collection/home quick-add buttons)
  function addToCart(variantId, quantity, callback){
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
    .then(function(res){ return res.json(); })
    .then(function(data){
      updateCartCount();
      if(callback) callback(data);
    })
    .catch(function(err){ console.error('Add to cart failed', err); });
  }

  function updateCartCount(){
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(res){ return res.json(); })
      .then(function(cart){
        document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = cart.item_count; });
      });
  }

  // Main product form submit (product page)
  var pdForm = document.getElementById('pdProductForm');
  if(pdForm){
    pdForm.addEventListener('submit', function(e){
      e.preventDefault();
      var variantId = pdForm.querySelector('[name="id"]').value;
      var qtyInput = pdForm.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var btn = pdForm.querySelector('[type="submit"]');
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      addToCart(variantId, qty, function(){
        btn.textContent = 'Added! ✓';
        setTimeout(function(){ btn.textContent = originalText; }, 1800);
      });
    });
  }

  // Quick-add buttons on home/collection grids
  document.querySelectorAll('[data-quick-add]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var variantId = btn.dataset.quickAdd;
      btn.style.transform = 'scale(1.3) rotate(90deg)';
      setTimeout(function(){ btn.style.transform = ''; }, 300);
      addToCart(variantId, 1);
    });
  });

  updateCartCount();
});
